import { render, staticRenderFns } from "./ScaleTypeMatch.vue?vue&type=template&id=f61219e8&scoped=true&"
import script from "./ScaleTypeMatch.vue?vue&type=script&lang=js&"
export * from "./ScaleTypeMatch.vue?vue&type=script&lang=js&"
import style0 from "./ScaleTypeMatch.vue?vue&type=style&index=0&id=f61219e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61219e8",
  null
  
)

export default component.exports